import PropTypes from 'prop-types';
import { Grid } from '@ui-propulsion/react-components';
import parse from 'html-react-parser';
import CtaButton from '../../ctaButton/ctaButton';
import styles from './content404.module.scss';

function Content404({
  headline = '',
  description = '',
  subTitle = '',
  cta = {},
  theme = '',
}) {
  const sectionStyle = { backgroundColor: theme };
  return (
    <div style={sectionStyle}>
      <Grid container className={styles.container}>
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          lg={3}
          className={styles.titleContainer}
        >
          <div className={styles.title}>
            <h1>{headline}</h1>
          </div>
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={5}>
          <div className={styles.details}>
            <h3>{subTitle}</h3>
            <div data-testid="description">{parse(`${description}`)}</div>
          </div>
        </Grid>
        <Grid item className={styles.button} xs={12} sm={4} md={4} lg={4}>
          {cta && (
            <CtaButton
              label={cta.label}
              href={cta.link}
              data-testid="cta-home"
              color={cta.color || 'red'}
              variant={cta.variant || 'solid'}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
}
export default Content404;

Content404.propTypes = {
  headline: PropTypes.string,
  description: PropTypes.string,
  subTitle: PropTypes.string,
  cta: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  theme: PropTypes.string,
};
